export default __webpack_public_path__ + "static/media/Pot1.e61fc774.svg";